import React from 'react';
import PropTypes from 'prop-types';
import RenderDaysCheckboxField from 'components/form/InputFields/RenderDaysCheckboxField';
import styled from 'styled-components';
import utils from 'helpers/utils';
import translate from 'components/hoc/translate';
import { getFormValues, reduxForm } from 'redux-form';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getRuleConfig } from 'helpers/rulesHelper';

const StyledInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

class AllowedDaysRules extends React.Component {
    componentDidMount() {
        const {
            initialize,
            type,
            value,
        } = this.props;

        const initialState = {};

        const config = getRuleConfig(utils.firstCharToLowerCase(type)).config;

        utils.each(config, (configValue, property) => {
            initialState[property] = value[property] || null;
        });

        initialize(initialState);
    }

    componentDidUpdate() {
        const {
            formValues,
            onUpdate,
        } = this.props;

        return onUpdate(formValues);
    }

    render() {
        return (
            <StyledInputWrapper>
                <RenderDaysCheckboxField name='value' style={ { width: '100%' } } />
            </StyledInputWrapper>
        );
    }
}

AllowedDaysRules.propTypes = {
    formValues: PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.number),
        ]),
    }),
    initialize: PropTypes.func.isRequired,
    onUpdate: PropTypes.func,
    type: PropTypes.string.isRequired,
    value: PropTypes.shape({
        value: PropTypes.arrayOf(PropTypes.number),
    }),
};

const mapStateToProps = (state, props) => {
    const {
        id,
        type,
    } = props;

    const form = `${ type }-${ id }`;

    return {
        form: form,
        formValues: getFormValues(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(mapStateToProps, null),
    reduxForm(),
);

export default enhance(AllowedDaysRules);



// WEBPACK FOOTER //
// ./src/pages/discounts/rules/types/AllowedDaysRules.js